import ReactDOM from 'react-dom';
import ActivityFeedPage from  '@/components/page/activityFeed/ActivityFeedPage';



const ActivityFeedPagePortal = () =>  {
    const targetContainer = document.getElementById('react-activity-feed-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(<ActivityFeedPage />, targetContainer);
}
export default ActivityFeedPagePortal;